module.exports = __webpack_public_path__ + "static/5payment-footer-a84abbee23a237fa2dbdcadde62a51f8.svg";